<script setup>
import useModelTable from "./hooks/useModelTable";
import useModelAdjust from "./hooks/useModelAdjust";
import { PROCESS_DEPLOY_STATUS } from "@/constants";
import { onMounted, reactive } from "vue";
import useSystemList from "../hooks/useSystemList";

const { systemList } = useSystemList();

const {
  searchRef,
  searchData,
  columns,
  tableLoading,
  tableData,
  pages,
  getList,
  handleReset,
} = useModelTable();

const { handleEdit, handleDelete, handleDeploy, handleExport } =
  useModelAdjust(getList);

onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '流程模型' }">
    <template #header-btn>
      <el-button type="primary" icon="Plus" @click="handleEdit()"
        >新增</el-button
      >
    </template>
    <template #search>
      <el-form :model="searchData" ref="searchRef" :inline="true">
        <el-form-item prop="key">
          <el-input v-model="searchData.key" placeholder="流程key" />
        </el-form-item>
        <el-form-item prop="systemId">
          <el-select
            v-model="searchData.systemId"
            placeholder="所属系统"
            style="width: 100%"
          >
            <el-option
              v-for="item in systemList"
              :key="item.id"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="name">
          <el-input v-model="searchData.name" placeholder="模型名称" />
        </el-form-item>
        <el-form-item prop="status">
          <el-select
            v-model="searchData.status"
            placeholder="部署状态"
            style="width: 100%"
          >
            <el-option
              v-for="item in PROCESS_DEPLOY_STATUS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="getList()"
            >搜索</el-button
          >
          <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        v-loading="tableLoading"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed || false"
            :min-width="120"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <el-tag
                v-if="item.prop == 'subFlag'"
                :type="row[item.prop] == 1 ? 'success' : 'danger'"
                >{{ row[item.prop] == 1 ? "是" : "否" }}</el-tag
              >
              <span v-if="item.prop == 'state'">
                {{ row.state?.desc }}
              </span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" fixed="right" width="200">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleEdit(row)"
              >修改</el-button
            >
            <el-button
              type="primary"
              link
              @click="handleDeploy(row)"
              v-if="row.state.value != 'act_model_status_003'"
              >部署</el-button
            >
            <el-button type="primary" link @click="handleExport(row)"
              >导出</el-button
            >
            <el-button type="danger" link @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :total="pages.total"
        v-model:current-page="pages.page"
        @update:current-page="getList"
        layout="->, prev, pager, next"
      />
    </template>
  </zh-table-page>
</template>

<style scoped></style>
